import type React from "react";
import { Link } from "react-router-dom";

const EventListPage: React.FC = () => {
	return (
		<div className="space-y-6">
			<div className="flex justify-between items-center">
				<h1 className="text-3xl font-bold">イベント一覧</h1>
				<Link to="/events/new" className="btn btn-primary">
					新規イベント作成
				</Link>
			</div>
			<div className="bg-white p-6 rounded-lg shadow">
				{/* イベント一覧を表示するコンポーネントをここに配置 */}
			</div>
		</div>
	);
};

export default EventListPage;
